module.exports = __webpack_public_path__ + "static/media/2@2x.d6138bf8.jpg";